import short from 'short-uuid';

const translator = short();
export function generateShortUUID(): string {
  return translator.new();
}